import { deleteAlarm, deleteAllAlarm } from "api/alarm";
import { mapAssetsDocs } from "api/docs";
import { deleteEquipment } from "api/equipments";
import { deleteExpression, deleteExpressions } from "api/expression";
import { deleteExplorerFiles, deleteFile, deleteFiles } from "api/fileManager";
import { deleteTag, deleteTags, mapEquipmentTag, mapTrainTag, mapUnitTag, resetTag } from "api/tags";
import { deleteTicket } from "api/tickets";
import { deleteTrain } from "api/trains";
import { deleteUnit } from "api/units";
import { deleteWidget } from "api/unity";

const dangerModalApiConfig = {
  deleteExpression,
  deleteExpressions,
  deleteExplorerFiles,
  deleteTag,
  deleteTags,
  resetTag,
  deleteFile,
  deleteFiles,
  deleteAlarm,
  deleteAllAlarm,
  deleteTicket,
  deleteEquipment,
  deleteTrain,
  deleteUnit,
  deleteWidget,
  mapAssetsDocs,
  unmapTag: {
    mapEquipmentTag,
    mapUnitTag,
    mapTrainTag
  }
};

export default dangerModalApiConfig;